import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import Alert from 'src/components/alert';
import { MODULE_TYPES_MAP } from 'src/constants/m-line';
import useActionPanelStore from 'src/stores/useActionPanelStore';

const UndockConfirmation = ({
  module,
  handleAction,
  allModulesUndock,
  hasActiveTransactionsForModule,
}) => {
  const { closeActionPanel } = useActionPanelStore();
  if (!module && !allModulesUndock) return null;
  const { name, type } = module ?? {};

  return (
    <div>
      <p>
        {allModulesUndock ? (
          <span>
            <strong>All modules</strong> will be undocked
          </span>
        ) : (
          <>
            <strong>{MODULE_TYPES_MAP[type]}</strong> module <strong>{name}</strong> will be
            undocked.
          </>
        )}
      </p>
      <div>Are you sure you want to proceed?</div>
      {hasActiveTransactionsForModule && (
        <Alert
          name='pendingTransactions'
          variant='warning'
          className='text-left d-flex align-items-center mt15'
        >
          <FontAwesomeIcon icon={faExclamationTriangle} className='font-size-22 mr15' />
          <div>
            <p className='font-medium mb0'>
              Warning: Once you undock a module with pending transactions, you will no longer be
              able to dock it to an LPS until reconciled at the MHS.
            </p>
          </div>
        </Alert>
      )}
      <button
        type='button'
        className='btn btn-lg btn-primary action-btn btn-block mt60'
        onClick={handleAction}
      >
        Undock
      </button>
      <button type='button' className='btn btn-lg btn-block' onClick={closeActionPanel}>
        Cancel
      </button>
    </div>
  );
};

UndockConfirmation.defaultProps = {
  allModulesUndock: false,
  module: null,
  hasActiveTransactionsForModule: false,
};

UndockConfirmation.propTypes = {
  module: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }),
  handleAction: PropTypes.func.isRequired,
  allModulesUndock: PropTypes.bool,
  hasActiveTransactionsForModule: PropTypes.bool,
};

export default UndockConfirmation;
